import Api from './WorkSpace.api';
import { message } from 'antd';
import { isEmpty as _isEmpty } from 'lodash-es';
import { WorkSpaceConstants } from './WorkSpace.constants';
import { UserError } from 'utilities/ErrorHandlling/ErrorHandlling';
import { getCustomDashboardList } from 'redux/CustomDashboard/CustomDashboard.action';
import { routesMapping } from 'utilities/utilities_exports';
import { t } from 'i18next';

// --- Format :: new API('API URL', 'API SERVICE NAME - from api_service.jsx')
const dashboard = new Api('', 'chart');

export const getWorkspaceDashboardDetails = id => {
  let apiData = {};
  return async dispatch => {
    try {
      dispatch({ type: WorkSpaceConstants.GET_WORKSPACE_SELECTED_DASHBOARD_CONFIG_REQUEST });
      apiData = await dashboard.getWorkspaceDashboardDetails(id);
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        const { data } = apiData;
        dispatch({
          type: WorkSpaceConstants.GET_WORKSPACE_SELECTED_DASHBOARD_CONFIG_SUCCESS,
          payload: { loading: false, error: false, ...data }
        });
      }
    } catch (error) {
      dispatch({ type: WorkSpaceConstants.GET_WORKSPACE_SELECTED_DASHBOARD_CONFIG_FAILED });
      throw new UserError(error);
    }
  };
};

export const onCreateECommerceDashboard = payload => {
  let apiData = {};
  return async dispatch => {
    try {
      apiData = await dashboard.onCreateECommerceDashboard(payload);
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        if (!_isEmpty(apiData?.data) && apiData?.status === 200) {
          dispatch(getCustomDashboardList());
          // const { dashboardId } = apiData?.data;
          // dispatch(getWorkspaceDashboardDetails(dashboardId));
        } else {
          message.error(t('GRAAS_FAILED_TO_CREATE_DASHBOARD_GRAAS'));
        }
      }
    } catch (error) {
      throw new UserError(error);
    }
  };
};

// export const onUpdateWorkSpaceDashboard = (payload, reload, isEditChart = false, chartID) => {
//   const { code, dashboardId, ...rest } = payload;
//   let apiData = {};
//   return async dispatch => {
//     try {
//       apiData = await dashboard.onUpdateWorkSpaceDashboard(rest, dashboardId);
//       if (apiData && apiData.hasError) {
//         throw apiData;
//       } else {
//         message.success(t('GRAAS_DASHBOARD_UPDATED_MSG_GRAAS'));
//         if (isEditChart) {
//           window.location.href = `/chart-builder/?dashboardId=${dashboardId}&visulaizationID=${chartID}`;
//         } else if (reload && reload === 'reload') {
//           var newUrl = `${routesMapping?.workspace}?id=${dashboardId}&tab=${code}`;
//           if (_isEmpty(rest?.visualisation_set)) {
//             newUrl = routesMapping?.workspace;
//           }
//           window.location.replace(newUrl);
//         } else {
//           dispatch(getCustomDashboardList());
//           dispatch(getWorkspaceDashboardDetails(dashboardId));
//         }
//       }
//     } catch (error) {
//       throw new UserError(error);
//     }
//   };
// };

export const onUpdateWorkSpaceVisulaizationSet = payload => {
  const { dashboardId, ...rest } = payload;
  let apiData = {};
  return async dispatch => {
    try {
      apiData = await dashboard.onUpdateWorkSpaceDashboard(rest, dashboardId);
      if (apiData && apiData.hasError) {
        throw apiData;
      }
    } catch (error) {
      throw new UserError(error);
    }
  };
};

export const onUpdateWDefaultDashboard = (payload, reload) => {
  const { dashboardId, ...rest } = payload;
  let apiData = {};
  return async dispatch => {
    try {
      apiData = await dashboard.onUpdateWDefaultDashboard(rest, dashboardId);
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        message.success(t('GRAAS_DASHBOARD_UPDATED_MSG_GRAAS'));
        if (reload && reload === 'reload') {
          const newUrl = `${routesMapping?.workspace}?id=${dashboardId}&tab=${payload?.tab}`;
          window.location.replace(newUrl);
        } else {
          dispatch(getCustomDashboardList());
          dispatch(getWorkspaceDashboardDetails(dashboardId));
        }
      }
    } catch (error) {
      throw new UserError(error);
    }
  };
};
